import React from "react";

const Home = () => {
    return(
        <div>
           <header className="">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
          <img src="assets/images/la-logo-240px.png" className="la-logo" alt=""></img>
            <a className="navbar-brand" href="/home"><h2>Lakshan Associates</h2></a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item active">
                  <a className="nav-link" href="/home">Home
                    <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/about">About Us</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/ourservices">Our Services</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/ourfacilities">Our Facilities</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
        {/* Banner Starts Here */}
        <div className="main-banner header-text" id="top">
            <div className="Modern-Slider">
              {/* Item */}
              <div className="item item-1">
                <div className="img-fill">
                  <div className="text-content">
                    <h6>We are certified&nbsp;&nbsp;<i className="fa fa-award"></i></h6>
                    <h4>Scrap Recycling <br/>&amp; Waste Management</h4>
                    <p>Bring us any size or amount of industrial or commercial scraps and we'll handle it with ease. You will get great prices on all of your scrap.</p>
                    <a href="services.html" className="filled-button">our services</a>
                  </div>  
                </div>
              </div>
              {/* // Item */}
              {/* Item */}
              <div className="item item-2">
                <div className="img-fill">
                  <div className="text-content">
                    <h6>we are Providing</h6>
                    <h4>Sustainable Solutions</h4>
                    <p>We provide sustainable waste management solutions that enable industries and cities to strengthen their environmental and economic performances.</p>
                    <a href="/contactus" className="filled-button">Contact Us</a>
                  </div>
                </div>
              </div>
              {/* // Item */}
              {/* Item */}
              <div className="item item-3">
                <div className="img-fill">
                    <div className="text-content">
                      <h6>We support you with</h6>
                      <h4>Prompt payment <br/>&amp; competitive prices</h4>
                      <p>Bring us any size or amount of industrial or commercial metal and we'll handle it with ease. You will get great prices on all of your scrap</p>
                      <a href="about.html" className="filled-button">learn more</a>
                    </div>
                </div>
              </div>
              {/* // Item */}
            </div>
        </div>
        {/* Banner Ends Here */}
        <div className="request-form">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <h4>Request a call back right now ?</h4>
                <span>Our help center is fresh and always open for business.</span>
              </div>
              <div className="col-md-4">
                <a href="/contactus" className="border-button">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
        <div className="services">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="section-heading">
                  <h2>Our <em>Services</em></h2>
                  <span>We provide the best services for our customers</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-item">
                  <img src="assets/images/service_01.jpg" alt="" />
                  <div className="down-content">
                    <h4>Scrap &amp; Waste Management</h4>
                    <p>We offer holistic scrap &amp; waste management solutions ranging from commercial to residential and to all points in the industry that helps them achieve their sustainable goals. Our services are in compliance with operational health and safety requirements as well as labour laws.</p>
                    <a href="#" className="filled-button">Read More</a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-item">
                  <img src="assets/images/service_02.jpg" alt="" />
                  <div className="down-content">
                    <h4>Aluminum Recycling</h4>
                    <p>Drop off your scrap aluminum items including: electric wiring &amp; cables, metal building construction materials from roofs, windows or doors &amp; packaging materials. We procure aluminum scrap in all grades at any volumes &amp; sizes. After recycling we supply the final Ingots to the manufactuing industries</p>
                    <a href="#" className="filled-button">Read More</a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-item">
                  <img src="assets/images/service_03.jpg" alt="" />
                  <div className="down-content">
                    <h4>Plastic Recycling</h4>
                    <p>Undertaking the reprocessing of almost every kind of Plastic compound,  employs advanced machinery and a skilled workforce so as to ensure that the viable properties of Plastic compounds are retained and the by-products thus manufactured are of the highest quality.</p>
                    <a href="#" className="filled-button">Read More</a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-item">
                  <img src="assets/images/service_04.jpg" alt="" />
                  <div className="down-content">
                    <h4>Wooden Recycling</h4>
                    <p>We help industries to get their waste wood recycled. We collect or purchase waste wood from clients and get it segregated as per quality and size of wood in our warehouses then get is converted in to artificial wood or plywood through our green partners.</p>
                    <a href="#" className="filled-button">Read More</a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-item">
                  <img src="assets/images/service_05.jpg" alt="" />
                  <div className="down-content">
                    <h4>Manpower Contract</h4>
                    <p>High Quality Labour Solutions for Industries! Our labour works are well known for their timely implementation, flexibility, and unmatched quality. They are well-skilled expertise in various industries by in total compliance.</p>
                    <a href="#" className="filled-button">Read More</a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-item">
                  <img src="assets/images/service_06.jpg" alt="" />
                  <div className="down-content">
                    <h4>Transport</h4>
                    <p>We have come up with more personalized transport solutions for material scraps, rubber scrap, copper scrap, plastic scrap, aluminium scrap, iron scrap, metal scrap, wooden scrap and industrial scrap.</p>
                    <a href="#" className="filled-button">Read More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fun-facts">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="left-content">
                  <h2>Our solutions for your <em>business growth</em></h2>
                  <p>We are on a mission to make recycling as easy and care-free as possible for your business. 
                    <br /><br />We have been an established in this industry with an excellent track record for the best customer satisfaction. We have never compromised on the quality of our services to the customer.</p>
                  <a href="#aboutus" className="filled-button">Read More</a>
                </div>
              </div>
              <div className="col-md-6 align-self-center">
                <div className="row">
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">55000</div>Sqft
                      <div className="count-title">Wooden Recycling Unit</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">5000</div>Sqft
                      <div className="count-title">Plastic Recycling Unit</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">100</div>plus
                      <div className="count-title">Workers &amp; Office Staffs</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">40</div>plus
                      <div className="count-title">Vehicles, Cranes, Lifts  &amp; JCBs</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="aboutus" className="more-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="more-info-content">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="left-image">
                        <img src="assets/images/more-info.jpg" alt="" />
                      </div>
                    </div>
                    <div className="col-md-6 align-self-center">
                      <div className="right-content">
                        <span>Who we are</span>
                        <h2>Get to know about <em>our company</em></h2>
                        <p>
                          Lakshan Associates is a licensed provider of waste management and recycling solutions with fully equipped facility to handle all sort of scraps.<br /><br />
                          Our core business include buying and selling of various kinds of scrap such as Waste Cortons, Wooden Wastes, General Wastes, Plastic Wastes, Aluminium, copper, chillers, stainless steel, brass, cables, scrap iron such as sheet piles, cutting plates, rebar, machinery, zinc, etc.<br /><br />
                          We also provide Transports, Demolition, Disposal and Clearing for buildings and heavy industries. With decades of knowledge and experiences, we have a dedicated team of experiences and knowledgeable workers who can solve your problems at the least provided time. With our own vehicles from 5 tons to heavy duty forklifts we complete our job promptly.<br /><br />
                          Lakshan Associates believes in not only providing the best price and service but also in making it easier for customers to sell their scraps at their convenience.
                        </p>
                        <a href="/about" className="filled-button">Know More</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="callback-form">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="section-heading">
                  <h2>Request a <em>call back</em></h2>
                  <span>Etiam suscipit ante a odio consequat</span>
                </div>
              </div>
              <div className="col-md-12">
                <div className="contact-form">
                  <form id="contact" method="post">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="name" type="text" className="form-control" id="name" placeholder="Full Name" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="email" type="text" className="form-control" id="email" pattern="[^ @]*@[^ @]*" placeholder="E-Mail Address" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="subject" type="text" className="form-control" id="subject" placeholder="Subject" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <textarea name="message" rows={6} className="form-control" id="message" placeholder="Your Message" required defaultValue={""} />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <button type="submit" id="form-submit" className="border-button">Send Message</button>
                        </fieldset>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="partners">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="owl-partners owl-carousel">
                  <div className="partner-item">
                    <img src="assets/images/clients/jpr.png" title={1} alt={1} />
                  </div>
                  <div className="partner-item">
                    <img src="assets/images/clients/pnp.png" title={2} alt={2} width={"50"} height={"60"}/>
                  </div>
                  <div className="partner-item">
                    <img src="assets/images/clients/Sumangala.png" title={3} alt={3} />
                  </div>
                  <div className="partner-item">
                    <img src="assets/images/clients/NOBLE.webp" title={4} alt={4} />
                  </div>
                  <div className="partner-item">
                    <img src="assets/images/clients/sastha.jpg" title={5} alt={5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Home;